import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'

const MetaTags = ({ resolvedUrl, album, filters, searchText, tag }) => {
  const pathName = resolvedUrl.split('?')[0]

  const isSearchPage = /search/.test(pathName)
  const filterByTags = filters?.length

  const originUrl = `${LS_APP_DOMAIN + pathName}`
  let path = originUrl
  if (isSearchPage) {
    path = `${originUrl}/search?keyword=${encodeURIComponent(searchText)}&page=1`
  } else if (filterByTags) {
    path = `${originUrl}?tag=${filters?.[0]}&page=1`
  } else {
    path = `${originUrl}?page=1`
  }

  let title = '室內設計裝潢風格分享，各種案例照片一籮筐－信義居家'
  let description =
    '彙整國內室內設計裝潢風格案例照片，無論是廚房/臥室/玄關/商業空間設計裝潢等，提供您各種風格、色系、格局裝潢參考，快來看看各種經典設計作品吧！!'

  if (isSearchPage) {
    title = `各式【${searchText}】居家設計、裝潢風格照片－信義居家`
    description = `你想找的${searchText}相關設計裝潢照片、居家風格照都在這！快來信義居家看看該如何為自己的家布置裝潢，找到自己最喜歡的居家風格，為生活增添更多色彩！`
  } else if (filterByTags) {
    if (tag?.name) {
      title = `各種【${tag?.name}】設計裝潢案例照片，找到屬於自己的居家風格－信義居家`
      description = `各種${tag?.name}設計裝潢案例照片都在這！快來看看如何將${tag?.name}靈活運用設計出自己喜歡的裝潢風格，讓整個居家空間更舒適、符合自己的居家生活習慣。`
    }
  }

  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: title,
        item: path,
      },
    ],
  }

  return (
    <Head>
      <title>{title}</title>

      <link key="canonical" rel="canonical" href={path} />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      {!!description && (
        <meta key="description" name="description" content={description} />
      )}

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      {!!description && (
        <meta
          key="og:description"
          property="og:description"
          content={description}
        />
      )}
      <meta
        key="og:image"
        property="og:image"
        content={album?.frontCover?.image?.url || ''}
      />
      <meta key="og:url" property="og:url" content={path} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </Head>
  )
}

export default MetaTags
